import React, { useEffect } from "react";
import LegalPageLayout from "@/components/LegalPageLayout";

export default function Datenschutz() {
  useEffect(() => {
    document.title = "Datenschutzerklärung — Rodex Berlin";
  }, []);

  return (
    <LegalPageLayout
      title="Datenschutzerklärung"
      intro="Informationen zur Verarbeitung personenbezogener Daten nach Art. 13 DSGVO"
    >
      <section>
        <h2>1. Verantwortlicher</h2>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
          <strong>Rodex Berlin – Philipp J. Thoma</strong><br />
          Manteuffelstr. 76, 10999 Berlin<br />
          E-Mail: <a href="mailto:info@rodex.berlin">info@rodex.berlin</a><br />
          Telefon: <a href="tel:+493034762216">030 34762216</a>
        </p>
      </section>

      <section>
        <h2>2. Allgemeine Hinweise zur Datenverarbeitung</h2>
        <p>
          Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
          Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
          erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung des Nutzers
          oder zur Erfüllung eines Vertrages bzw. vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. a
          und b DSGVO).
        </p>
      </section>

      <section>
        <h2>3. Erhebung beim Besuch der Website (Server-Logs)</h2>
        <p>
          Beim Aufruf unserer Website werden durch den Browser automatisch Informationen an den
          Server unseres Hosters gesendet und vorübergehend in einem Logfile gespeichert (IP-Adresse,
          Datum und Uhrzeit des Zugriffs, abgerufene URL, Referrer-URL, verwendeter Browser/OS).
          Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem
          stabilen, sicheren Betrieb). Die Daten werden nach maximal 30 Tagen gelöscht.
        </p>
      </section>

      <section>
        <h2>4. Kontaktformular und Lead-Anfragen</h2>
        <p>
          Wenn Sie über unser Kontaktformular Kontakt mit uns aufnehmen, werden folgende Daten
          verarbeitet: Name, Telefonnummer, E-Mail-Adresse, ggf. Adresse, Art der Anfrage und
          Beschreibung. Die Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage und für den
          Fall von Anschlussfragen gespeichert.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen)
          bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter
          Kommunikationsbearbeitung).<br />
          <strong>Speicherdauer:</strong> bis zur vollständigen Bearbeitung Ihres Anliegens,
          längstens jedoch bis zum Ablauf gesetzlicher Aufbewahrungsfristen (i. d. R. 6 bzw. 10
          Jahre bei Vertragsabschluss).<br />
          <strong>Empfänger:</strong> Die Daten werden ausschließlich intern bei Rodex Berlin
          verarbeitet und nicht an Dritte weitergegeben.
        </p>
      </section>

      <section>
        <h2>5. Hosting</h2>
        <p>
          Diese Website wird bei Emergent Labs gehostet. Mit dem Hoster wurde ein Vertrag über die
          Auftragsverarbeitung gemäß Art. 28 DSGVO geschlossen. Daten werden ausschließlich innerhalb
          der EU verarbeitet.
        </p>
      </section>

      <section>
        <h2>6. Cookies</h2>
        <p>
          Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den
          ordnungsgemäßen Betrieb der Seite erforderlich sind (z. B. Sitzungs-Cookies). Es werden
          keine Tracking- oder Marketing-Cookies eingesetzt, die einer Einwilligung bedürfen würden.
        </p>
      </section>

      <section>
        <h2>7. Google Fonts</h2>
        <p>
          Diese Website nutzt zur einheitlichen Darstellung von Schriftarten &bdquo;Google Fonts&ldquo; der
          Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Beim Aufruf einer
          Seite lädt Ihr Browser die benötigten Schriften, wobei eine Verbindung zu den Servern von
          Google aufgebaut wird. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
          an einer ansprechenden Darstellung).
        </p>
      </section>

      <section>
        <h2>8. Ihre Rechte</h2>
        <p>Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:</p>
        <ul>
          <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
          <li>Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
        </ul>
        <p>
          Zur Ausübung Ihrer Rechte genügt eine formlose E-Mail an{" "}
          <a href="mailto:info@rodex.berlin">info@rodex.berlin</a>.
        </p>
      </section>

      <section>
        <h2>9. Beschwerderecht bei der Aufsichtsbehörde</h2>
        <p>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung
          Ihrer personenbezogenen Daten durch uns zu beschweren. Zuständig ist die Berliner
          Beauftragte für Datenschutz und Informationsfreiheit, Friedrichstr. 219, 10969 Berlin.
        </p>
      </section>

      <section>
        <h2>10. SSL-/TLS-Verschlüsselung</h2>
        <p>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
          Inhalte eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am
          &bdquo;https://&ldquo; in der Adresszeile sowie am Schlosssymbol im Browser.
        </p>
      </section>

      <p className="text-xs text-slate-500 pt-6 border-t border-slate-200">
        Stand: 2025.
      </p>
    </LegalPageLayout>
  );
}
